import React from "react";

// Import typefaces
import "typeface-montserrat";
import "typeface-merriweather";

import profilePic from "./mitch-profile-pic.jpg";
import { rhythm } from "../utils/typography";

class Slugline extends React.Component {
  render() {
    return (
      <div
        style={{
          display: "flex"
        }}>
        <p>A Tesla+Kansas blog by the Mitchell Family.</p>
      </div>
    );
  }
}

export default Slugline;



// WEBPACK FOOTER //
// ./src/components/slugline.js